import React from 'react';
import { observer } from 'mobx-react-lite';
import Grid from '@material-ui/core/Grid';
import styles from './ContactInfoEmail.module.css';

// eslint-disable-next-line prefer-arrow-callback,sonarjs/cognitive-complexity
const ContactInfoEmail = observer(function ContactInfoPhoneNumber(props) {
  const { email, isWebChatChannel } = props;

  const componentStyles = {
    itemContainer: !isWebChatChannel
      ? styles.itemContainer
      : [styles.itemContainer, styles.itemContainerWebChat].join(' '),
    email: !isWebChatChannel ? styles.email : [styles.email, styles.emailWebChat].join(' '),
  };

  const sendEmail = () => {
    const mailWindow = window.open(
      `mailto:${email.Email}`,
      'Popup',
      'height=100, width=100, status=no, toolbar=no, menubar=no, location=no, top=1, right=1'
    );
    mailWindow.blur();
    mailWindow?.close();
  };

  return (
    <React.Fragment>
      <Grid component="div" container key={`p-${email}`} className={componentStyles.itemContainer}>
        <Grid
          component="div"
          container
          item
          xs={12}
          className={styles.overflowFix}
          alignContent="center"
          alignItems="center"
          onClick={sendEmail}
        >
          <span className={componentStyles.email} data-testid="email">
            {email.Email}
          </span>
        </Grid>
      </Grid>
    </React.Fragment>
  );
});
ContactInfoEmail.whyDidYouRender = true;
ContactInfoEmail.displayName = 'ContactInfoEmail';

export default ContactInfoEmail;
